import React from "react";
import ReactDOM from "react-dom/client";
import store from "redux/store";
import { Provider } from "react-redux";
import Root from "root";
import ErrorBoundary from "components/app/errorBoundary";
import { ConfigProvider } from "antd";
import ko_KR from "antd/lib/locale/ko_KR";
import en_US from "antd/es/locale/en_US";
import i18n from "react-i18next";
import "font/font.css";

const customLocale = {
  ...ko_KR,
  DatePicker: {
    ...ko_KR.DatePicker,
    lang: {
      ...ko_KR.DatePicker.lang,
      now: "지금",
    },
  },
};

/**
 * 파일명: index.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: index
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <ConfigProvider
        // locale={customLocale}
        // locale={i18n.useTranslation().language() === 'ko-KR' ? ko_KR : en_US}
        theme={{
          token: {
            fontFamily: "SpoqaHanSansNeo",
          },
          components: {
            Checkbox: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorTextPlaceholder: "#909090",
            },
            Input: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorTextPlaceholder: "#909090",
            },
            DatePicker: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorTextPlaceholder: "#909090",
            },
            Select: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorTextPlaceholder: "#909090",
            },
            Button: {
              borderRadius: 5,
              fontSize: 16,
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1AA886",
              colorPrimaryActive: "#1cb691",
              colorText: "#2a2a2a",
              colorTextDisabled: "#2a2a2a",
              colorTextLightSolid: "#fff",
              colorError: "#e6e6e6",
              colorErrorHover: "#6b6b6b",
              colorErrorActive: "#6b6b6b",
            },
            Tabs: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
            Menu: {
              itemColor: "#fff",
              itemHoverColor: "rgba(255, 255, 255, 0.7)",
              horizontalItemHoverColor: "#e0ff8d",
              itemSelectedColor: "#e0ff8d !important",
              itemSelectedBg: "rgba(224, 255, 141, 0.24)",
              controlItemBgActive: "rgba(224, 255, 141, 0.24)",
              colorBgElevated: "#000000",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
            Radio: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
            Cascader: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
            Switch: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
            Pagination: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
            Table: {
              colorPrimary: "#1cb691",
              colorFillAlter: "#fff",
              colorBorder: "#b4b4b4",
              colorTextPlaceholder: "#909090",
            },
          },
        }}
      >
        <Root />
      </ConfigProvider>
    </ErrorBoundary>
  </Provider>
);
